import React from 'react';
import './LoadingProgress.css';

interface LoadingProgressProps {
  progress: number;  // 0-100
  message?: string;
}

export const LoadingProgress: React.FC<LoadingProgressProps> = ({ progress, message }) => {
  return (
    <div className="loading-progress">
      <div className="loading-progress-bar">
        <div
          className="loading-progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      {message && <p className="loading-progress-message">{message}</p>}
    </div>
  );
};